import { useTranslation } from 'react-i18next';

import {
  ErrorAlertWrapper,
  ErrorAlertIcon,
  ErrorAlertContent,
  ErrorAlertTitle,
  ErrorAlertClose
} from './ErrorAlert.styles';

import { Icon } from '@/components/Icon';
import { FileErrorType } from '@/types/file';

interface ErrorAlertProps {
  errorType: FileErrorType;
  maxSize?: number;
  acceptedTypes: string[];
  onClose: () => void;
}
const WARNING_ICON_SIZE = 20;
const CLOSE_ICON_SIZE = 16;

export const ErrorAlert: React.FC<ErrorAlertProps> = ({
  errorType,
  maxSize = 10,
  acceptedTypes,
  onClose
}) => {
  const { t } = useTranslation();

  const errorConfig = {
    size: {
      title: t('DefaultTranslations:FILE_TOO_LARGE_TITLE', { max: maxSize })
    },
    format: {
      title: t('DefaultTranslations:INVALID_FILE_TYPE_TITLE', {
        formats: acceptedTypes.join(', ')
      })
    },
    multiple: {
      title: t('DefaultTranslations:MULTIPLE_FILES_TITLE')
    }
  };

  const config = errorConfig[errorType];

  return (
    <ErrorAlertWrapper>
      <ErrorAlertIcon>
        <Icon i="WarningFilled" size={WARNING_ICON_SIZE} />
      </ErrorAlertIcon>
      <ErrorAlertContent>
        <ErrorAlertTitle>{config.title}</ErrorAlertTitle>
      </ErrorAlertContent>
      <ErrorAlertClose onClick={onClose}>
        <Icon i="Close" size={CLOSE_ICON_SIZE} />
      </ErrorAlertClose>
    </ErrorAlertWrapper>
  );
};
